export const baseFolder = '/payments';
export const ACCESS_CODE_LENGTH = 8;

export const SPRUCE_PHONE_NUMBER = '(888) 665-7535';
export const ZILLOW_CLOSING_BRAND_NAME = 'Zillow Closing';
